// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const ROLE_BASE_URL = '/api/v1/roles/';

/**
 * 获取角色列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getRoleList(
  params?: OA.RoleListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RoleListData>>(ROLE_BASE_URL, {
    method: 'GET',
    params: params || {},
    ...(options || {}),
  });
}

/**
 * 创建角色
 * @param data 角色数据
 * @param options 请求配置
 */
export async function createRole(
  data: OA.CreateRoleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<{ id: number }>>(ROLE_BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取角色详情
 * @param roleId 角色ID
 * @param options 请求配置
 */
export async function getRoleDetail(
  roleId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RoleDetail>>(`${ROLE_BASE_URL}${roleId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 更新角色信息
 * @param roleId 角色ID
 * @param data 更新数据
 * @param options 请求配置
 */
export async function updateRole(
  roleId: number,
  data: OA.UpdateRoleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${ROLE_BASE_URL}${roleId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除角色
 * @param roleId 角色ID
 * @param options 请求配置
 */
export async function deleteRole(
  roleId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${ROLE_BASE_URL}${roleId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 分配角色给用户
 * @param data 分配参数
 * @param options 请求配置
 */
export async function assignRole(
  data: OA.AssignRoleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${ROLE_BASE_URL}assign`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 撤销用户角色
 * @param data 撤销参数
 * @param options 请求配置
 */
export async function revokeRole(
  data: OA.RevokeRoleParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<null>>(`${ROLE_BASE_URL}revoke`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

